/* eslint-disable react/prefer-stateless-function */
import React, { Component } from "react";

class Error404 extends Component {
  render() {
    return (
      <div>
        <h1>404 - Page Not Found</h1>
      </div>
    );
  }
}

export default Error404;
